import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { Valuta } from './valuta';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-valuta-update',
  templateUrl: './valuta-update.component.html'
})
export class ValutaUpdateComponent extends BaseUpdateComponent<Valuta> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Sifra", Validators.required, 'required', 'VALUTA.SIFRANUMERIC.VALIDATION.REQUIRED');
    this.addValidatorToFc("Sifra", Validators.maxLength(3), 'maxlength', 'VALUTA.SIFRANUMERIC.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Sifra", Validators.pattern('[0-9]{3}'), 'pattern', 'VALUTA.SIFRANUMERIC.VALIDATION.PATTERN');
    this.addValidatorToFc("ISOAlpha3Code", Validators.required, 'required', 'VALUTA.ISOALPHA3CODE.VALIDATION.REQUIRED');
    this.addValidatorToFc("ISOAlpha3Code", Validators.maxLength(3), 'maxlength', 'VALUTA.ISOALPHA3CODE.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("ISOAlpha3Code", Validators.pattern('[A-Z]{3}'), 'pattern', 'VALUTA.ISOALPHA3CODE.VALIDATION.PATTERN');
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'VALUTA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(50), 'maxlength', 'VALUTA.NAZIV.VALIDATION.MAXLENGTH');
  }

}
